import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Footer extends Component {
  
  render() {
    const currentYear = new Date();

    return(
      <footer className="footer">
        <div className="brand">
          © Pinstripe {currentYear.getFullYear()}
        </div>
        <ul className="account">
          <a href="mailto:hello@pinstripelabs.com">Contact Support</a>
          <Link to="/privacy">Privacy</Link>
        </ul>
      </footer>
    );
  }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js